/**
 * GraphQL APIクライアント
 * Cloud RunのGraphQLエンドポイントにリクエストを送信
 */
import axios from "axios";
import { getAPIToken } from "./firebaseAuthentication";
import { APPLICATION_NAME } from "../constant/applicationConstant";
import { resolveFieldSurveyMock } from "../mock/fieldSurveyMock";
const GRAPHQL_ENDPOINT = `${process.env.APP_API_URL}j21spb32/graphql`;
async function graphqlRequest(query, variables) {
    const response = await axios.post(GRAPHQL_ENDPOINT, { query, variables }, {
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + (await getAPIToken()),
            "Application-Name": APPLICATION_NAME + "-" + process.env.ENVIRONMENT_MODE,
        }
    });
    if (response.data.errors) {
        console.error("GraphQL errors:", response.data.errors);
        throw new Error(response.data.errors[0]?.message || "GraphQL request failed");
    }
    return response.data.data;
}
export async function graphqlQuery(query, variables) {
    // モック: 現地調査依頼のoperationはダミーデータを返す（通信しない）
    const mock = resolveFieldSurveyMock(query, variables);
    if (mock !== undefined)
        return mock;
    return await graphqlRequest(query, variables);
}
export const fetchPagePermissions = async () => {
    const data = await graphqlQuery(`
        query getPagePermissions {
            pagePermissions {
                pageId
                permissionType
            }
        }
    `);
    return data.pagePermissions || [];
};
export const fetchOperationPermissions = async () => {
    const data = await graphqlQuery(`
        query getOperationPermissions {
            operationPermissions {
                pageId
                permissionType
                ssNewRequest
                ssRevision
                ssApprove
                ssHistory
                ssReRequest
                rsNewRequest
                rsRevision
                rsApprove
                rsHistory
                rsReRequest
                handlingCategory
            }
        }
    `);
    return data.operationPermissions || [];
};
